export default __webpack_public_path__ + "static/media/recall.bc2e30ae.png";